<template>
    <div class="row">
        <div class="col-12">
            <card>
                <div class="card-body">
                    <div class="mb-4">
                        <label class="text-uppercase px-1 mb-0 text-muted">
                            <small>{{$t('part.text.showcategory')}}:</small>
                        </label>
                        <a
                            @click.prevent="onFilterSet"
                            class="btn btn-xs btn-primary px-1 mr-1 mb-1"
                            href
                            data-category-id="all"
                            :disabled="options.params.category == 'all'"
                        >All</a>
                        <slot v-for="category in categories">
                            <a
                                @click.prevent="onFilterSet"
                                class="btn btn-xs btn-primary px-1 mr-1 mb-1"
                                href
                                :data-category-id="category.id"
                                :disabled="options.params.category == category.id"
                            >{{$t('part.categories.' + category.name.toLowerCase())}}</a>
                        </slot>

                        <div class="float-right" v-if="isAdmin">
                          <button class="btn btn-secondary btn-sm" @click="export2Excel">
                            <i class="fas fa-download fa-fw"></i> Download XLS
                          </button>
                        </div>

                    </div>

                    

                    <v-server-table
                        ref="vuetable"
                        url="/dtable/parts"
                        :columns="columns"
                        :options="options"
                    >
                        <template slot="beforeFilter">
                            <h2>
                                <i class="fas fa-cogs text-primary"></i> {{$t('part.title')}}
                            </h2>
                        </template>
                        <template slot="afterLimit">
                            <router-link class="btn btn-primary ml-2" :to="{ name: 'parts_new' }">
                                <i class="fas fa-plus fa-fw"></i> {{$t('part.button.addnew')}}
                            </router-link>
                        </template>
                        <template slot="id" slot-scope="props" class="btn-group" role="group">
                            <router-link
                                class="btn btn-xs btn-primary mr-1"
                                :to="{ name: 'parts_edit', params: { id: props.row.id } }"
                            >
                                <i class="fas fa-edit fa-fw"></i>
                            </router-link>
                            <router-link
                                class="btn btn-xs btn-primary mr-1"
                                :to="{ name: 'parts_delete', params: { id: props.row.id } }"
                            >
                                <i class="fas fa-trash-alt fa-fw"></i>
                            </router-link>
                        </template>
                    </v-server-table>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      columns: ["sku", "name", "code", "img", "created_at", "id"],
      options: {
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          sku: () => this.$t('field.sku'),
          name: () => this.$t('field.name'),
          code: () => this.$t('field.code'),
          img: () => this.$t('field.image'),
          created_at: () => this.$t('field.createdat'),
          id: ""
        },
        texts: {
          count: this.$t('field.count'),
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
          limit: this.$t('field.limit'),
        },
        orderBy: {
          ascending: false,
          column: "sku"
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        params: {
          category: "all"
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    },
    categories() {
      console.log(this.$store.getters);
      return this.$store.getters["parts/getCategories"];
    }
  },
  methods: {
    onFilterSet(e) {
      this.options.params.category = e.target.getAttribute("data-category-id");
      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    export2Excel() {
      import('@/excel/Export2Excel').then(excel => {
        
        const tHeader = this.columns.slice(0, -1);//['Serial number', 'Nickname?', 'Full name'];  // Set the title of the first row of Excel table
        const filterVal = this.columns.slice(0, -1);//['index', 'nickName', 'name'];  // index, nickName and name are properties of objects in tableData
        const list = this.$refs.vuetable.data;  //Save tableData in data to list
        const data = this.formatJson(filterVal, list);
        
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: this.$t('global.repairs') + '_' + this.getCurrentDate(), //Optional
          autoWidth: true, //Optional
          bookType: 'xlsx' //Optional
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  },
  created() {
    this.$store.dispatch("parts/getCategories");
  }
};
</script>
<style></style>
